import { useRef } from 'react'
import { useParams } from 'react-router-dom-v5-compat'

import { GuestRegistryHeader } from 'registry/components/GuestRegistryHeader/GuestRegistryHeader'
import RegistryGiftGiverPageSeo from '../RegistryGiftGiverPageSeo'
import RegistryBackBannerPortal from '../RegistryBackBannerPortal/RegistryBackBannerPortal'
import useScrollToElement from '../../hooks/useScrollToElement/useScrollToElement'
import useGetRegistry from '../../hooks/useGetRegistry'
import useGetRegItemsMinimal from '../../hooks/useGetRegItemsMinimal'
import css from './RegistryGiftGiverPage.styles.scss'
import useGetSortFilterOptions from '../../hooks/useGetSortFilterOptions'
import useGetReservations from '../../hooks/useGetReservations'
import { useAppliedSortsAndFilters } from './RegistryGiftGiverPage.utils'
import RegistryCategoryFilters from '../RegistryCategoryFilters/RegistryCategoryFilters'
import RegistrySortFilterDropdowns from '../RegistrySortFilterDropdowns/RegistrySortFilterDropdowns'

const RegistryGiftGiverPage = () => {
  const { slug } = useParams()
  const purchasedItemsRef = useRef<HTMLDivElement>(null)
  const { registry } = useGetRegistry(slug)
  const { regItems } = useGetRegItemsMinimal(registry.id)
  const { sortFilterOptions } = useGetSortFilterOptions(registry.id)
  const { reservations, reservationsQuery } = useGetReservations(registry.id)
  const { appliedSortsAndFilters, handleSortFilterChange } =
    useAppliedSortsAndFilters()

  useScrollToElement({
    isEnabled: !reservationsQuery.isLoading,
    ref: purchasedItemsRef,
    queryParam: { param: 'showGiftTracker', value: 'true' },
  })

  return (
    <div
      className={css.RegistryGiftGiverPage}
      data-testid="RegistryGiftGiverPage"
    >
      <RegistryBackBannerPortal registry={registry} />

      <RegistryGiftGiverPageSeo registry={registry} slug={slug} />

      {registry.title && (
        <GuestRegistryHeader
          arrivalDate={registry.family?.arrivalDate}
          note={registry.description}
          photoUrl={registry.photoUrl}
          registry={registry}
          title={registry.title}
        />
      )}

      <div className={css.RegistryGiftGiverPage__Content}>
        <div className={css.RegistryGiftGiverPage__Categories}>
          <RegistryCategoryFilters
            appliedSortsAndFilters={appliedSortsAndFilters}
            sortFilterOptions={sortFilterOptions}
            onSortFilterChange={handleSortFilterChange}
          />
        </div>

        <div className={css.RegistryGiftGiverPage__Dropdowns}>
          <RegistrySortFilterDropdowns
            appliedSortsAndFilters={appliedSortsAndFilters}
            firstNames={registry.firstNames}
            sortFilterOptions={sortFilterOptions}
            onSortFilterChange={handleSortFilterChange}
          />
        </div>

        <h2 ref={purchasedItemsRef}>Reg Items</h2>
        {regItems.map((regItem) => (
          <div key={regItem.id}>{regItem.title}</div>
        ))}

        <h2 ref={purchasedItemsRef}>Purchased</h2>
        {Object.values(reservations).map((reservation) => (
          <div key={reservation.id}>{reservation.id}</div>
        ))}
      </div>
    </div>
  )
}

export default RegistryGiftGiverPage
